import * as React from "react"
import * as Model from "../../../../../../model"
import { CardModal, CardModalType, CardModalNotOkButton } from "../../../../../modal"
import { NotificationProps } from "../../../../../notification"

class AccountModalPresenter extends React.Component<AccountModalPresenterProps> {
	render() {
		const disabled = this.props.loadingChapters || this.props.loading || this.props.loadingDelete || this.props.loadingUpdate
		const laca = this.props.laca
		const account = this.props.account;
		const chapter = this.props.chapter
		const isLoading = this.props.loadingChapters ? "is-loading" : ""
		const title = laca.account.id
			? `Modifier le compte ${account.number} - ${account.label}`
			: "Créer un compte"

		return <CardModal
		active={true}
		loading={this.props.loading || this.props.loadingDelete}
		title={title}
		type={CardModalType.ValidCancelDelete}
		notification={this.props.notification}
		onClickNotificationCloseButton={e => this.props.onClickNotificationCloseButton(e)}
		onClickCloseButton={this.props.onClickCloseButton}
		onClickDeleteButton={this.props.onClickDeleteButton}
		onClickFooterButton={this.props.onClickFooterButton}
		onSubmit={this.props.onSubmit}>
			<div className="columns">
				<div className="column is-one-third">
					<div className="field">
						<label className="label">Numéro</label>
						<div className="control">
							<input className="input is-static"
							disabled={this.props.loading}
							name={Names.Number}
							onChange={this.props.onChange}
							placeholder="123456"
							required
							type="text"
							value={account.number} />
						</div>
					</div>
				</div>
				<div className="column">
					<div className="field">
						<label className="label">Libellé</label>
						<div className="control">
							<input className="input is-static"
							disabled={this.props.loading}
							name={Names.Label}
							onChange={this.props.onChange}
							placeholder="Nouveau compte"
							required
							type="text"
							value={account.label} />
						</div>
					</div>
				</div>
			</div>
			<div className="field">
				<label className="label">Chapitre</label>
				<div className="control">
					<div className={`select is-fullwidth ${isLoading ? "is-loading" : ""}`}>
						<select disabled={disabled} name={Names.Chapter} onChange={this.props.onChange} required value={chapter ? chapter.id.toString() : ""}>
							<option disabled value="">Aucun</option>
							{this.props.chapters.map((ch, i) => (
								<option key={i} value={ch.id}>{ch.number} - {ch.label}</option>
							))}
						</select>
					</div>
				</div>
			</div>
			<div className="field">
				<div className="control">
					<label className="checkbox">
						<input checked={account.receipts} disabled={this.props.loading} name={Names.Receipts} onChange={this.props.onChange} readOnly={this.props.loading} type="checkbox" /> En recette
					</label> <label className="checkbox">
						<input checked={account.expense} disabled={this.props.loading} name={Names.Expense} onChange={this.props.onChange} readOnly={this.props.loading} type="checkbox" /> En dépense
					</label>
				</div>
			</div>
			<div className="field">
				<div className="control">
					<label className="radio">
						<input checked={account.operation} disabled={this.props.loading} name={Names.Operation} onChange={this.props.onChange} readOnly={this.props.loading} type="radio" value={1} /> En fonctionnement
					</label> <label className="radio">
						<input checked={!account.operation} disabled={this.props.loading} name={Names.Operation} onChange={this.props.onChange} readOnly={this.props.loading} type="radio" value={0} /> En investissement
					</label>
				</div>
			</div>
		</CardModal>
	}
}

export default AccountModalPresenter

export interface AccountModalPresenterProps {
	account?: Model.Account
	chapter?: Model.Chapter
	chapters: Model.Chapter[]
	classes: Model.Class[]
	instruction: Model.Instruction
	laca: Model.LocalAuthorityChapterAccount
	loading: boolean
	loadingChapters: boolean
	loadingDelete: boolean
	loadingUpdate: boolean
	notification?: NotificationProps
	onClickNotificationCloseButton?(e: React.SyntheticEvent<Element>): void
	onChange(e: React.SyntheticEvent<Element>): void
	onClickCloseButton(e: React.SyntheticEvent<Element>): void
	onClickDeleteButton?(button: CardModalNotOkButton.Delete, e: React.SyntheticEvent<Element>): void
	onClickFooterButton(button: CardModalNotOkButton, e: React.SyntheticEvent<Element>): void
	onSubmit(e: React.SyntheticEvent<Element>): void
}

export enum Names {
	ApplyToLocalAuthorities = "apply-to-local-authorities",
	Class = "class",
	DefaultChapter = "default-chapter",
	Chapter = "chapter",
	Expense = "expense",
	Label = "label",
	Number = "number",
	Operation = "operation",
	Receipts = "receipts",
	Template = "template"
}


// WEBPACK FOOTER //
// ./src/component/local-authority/local-authority-detail/instruction-card/instruction-list/edit-account-modal/edit-account-modal-presenter.tsx